// @ts-nocheck

import { MultiviewStorage } from '../constants/multiview';
import { MatchEntity } from '../states/entities/matches';
import { MultiviewActionTypes } from '../types/actions/multiview';
import { MultiviewDisplayModes } from '../types/multiview';
import { storage as StorageUtils } from '../utils';

export const multiviewInitialState = {
  showMatchList: false,
  mode: MultiviewDisplayModes.NORMAL,
  list: [],
  // Display options
  displayOptions: [],
  itemPerLine: 4,
  userOption: 4,
  showWTV: true,
  scrollToHeader: false,
};

const initialState = {
  showMatchList: false,
  mode: MultiviewDisplayModes.NORMAL,
  list: [],
  // Display options
  displayOptions: [],
  itemPerLine: 4,
  userOption: 4,
  showWTV: true,
  scrollToHeader: false,
};

// Browsing session lifetime state in session storage
const persistedMultiviewState = StorageUtils.sessionStorage.load(MultiviewStorage.KEY);
if (persistedMultiviewState && persistedMultiviewState.version === MultiviewStorage.VERSION) {
  initialState.list = persistedMultiviewState.state.list;
  initialState.userOption = persistedMultiviewState.state.userOption;
}

export default (state = initialState, action, rootState) => {
  switch (action.type) {
    case MultiviewActionTypes.SET_SCROLL_TO_HEADER: {
      const { value } = action.payload;
      return {
        ...state,
        scrollToHeader: value,
      };
    }
    case MultiviewActionTypes.SET_DISPLAY_OPTIONS: {
      const { value } = action.payload;
      return {
        ...state,
        displayOptions: value,
      };
    }
    case MultiviewActionTypes.SET_SHOW_MATCH_LIST: {
      const { value } = action.payload;
      return {
        ...state,
        showMatchList: value,
      };
    }
    case MultiviewActionTypes.SET_ITEM_PER_LINE: {
      const { itemPerLine } = action.payload;
      return {
        ...state,
        itemPerLine,
      };
    }
    case MultiviewActionTypes.SET_USER_OPTION: {
      const { userOption } = action.payload;
      return {
        ...state,
        userOption,
      };
    }
    case MultiviewActionTypes.SET_DISPLAY_MODE: {
      const { mode } = action.payload;
      return {
        ...state,
        mode,
      };
    }
    case MultiviewActionTypes.ADD_MATCH: {
      const { matchId } = action.payload;
      return {
        ...state,
        list: state.list
          .concat(matchId)
          .filter((matchId) => !MatchEntity.isEnded(rootState.entities.matches?.[matchId])),
      };
    }
    case MultiviewActionTypes.DEL_MATCH: {
      const { matchId } = action.payload;
      const index = state.list.indexOf(matchId);
      return {
        ...state,
        list: [...state.list.slice(0, index), ...state.list.slice(index + 1)].filter(
          (matchId) => !MatchEntity.isEnded(rootState.entities.matches?.[matchId]),
        ),
      };
    }
    default:
      return state;
  }
};
